<section class="d-flex w-100 justify-content-between mt-2">
    <section class="btn-toolbar">
        <div class="ms-2">
            <p>Periode: </p>
        </div>
        <div class="ms-2">
            <app-month-picker
                              id="til"
                              name="til"
                              #til="ngModel"
                              (monthChange)="onPeriodeChange($event, til.valid)"
                              [ngModel]="periode"
                              mask="LL-yy"
                              placeholder="mm-åå"
                              ></app-month-picker>
        </div>

        <app-statistik-options-grupper class="d-flex" (selectGruppe)="onSelectGruppe($event)"></app-statistik-options-grupper>

        <div class="ms-2">
            <p>Decimaler: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="laselect5" ngbDropdownToggle>
                {{ selectedDecimal !== null && selectedDecimal !== undefined ? selectedDecimal : '- Vælg -' }}
            </button>
            <div ngbDropdownMenu aria-labelledby="laselect5">
                <button *ngFor="let decimal of decimals" (click)="onSelectDecimal(decimal)" class="dropdown-item">{{decimal}}</button>
            </div>
        </div>

        <div class="ms-2">
            <p>Deciminutter: </p>
        </div>
        <div class="ms-2">
            <input type="checkbox" [(ngModel)]="inDeciminutes" (change)="onSelectDeciminuts(inDeciminutes)">
        </div>
    </section>
    <section class="btn-toolbar me-2">
        <div class="ms-2">
            <button (click)="onExportExcel()" class="btn btn--menu btn-primary btn-sm" type="submit">Eksport</button>
        </div>
    </section>
</section>
